export const roles = {
  vcso: "VCSO",
  viewer: "Viewer",
  admin: "Admin",
};
